import React, { useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';
import { RING_PATH } from '../home/v3/LogoMark';

gsap.registerPlugin(ScrollTrigger, useGSAP);

/**
 * Topo das páginas internas: título em linhas que sobem de dentro da máscara,
 * o anel do logo se desenhando grande ao fundo (e girando com o scroll).
 * `lines`: array de strings; itens { text, accent } ficam em verde.
 */
function PageHero({ lines, lede, children, className = '', compact = false }) {
  const root = useRef(null);

  useGSAP(
    () => {
      const q = gsap.utils.selector(root);
      const mm = gsap.matchMedia();
      mm.add('(prefers-reduced-motion: no-preference)', () => {
        const ring = q('.pg-ring path')[0];
        const len = ring.getTotalLength();
        gsap
          .timeline({ delay: 0.15 })
          .fromTo(q('.pg-rise'), { y: 0, yPercent: 115, rotate: 5 }, { yPercent: 0, rotate: 0, duration: 1.2, ease: 'expo.out', stagger: 0.08 })
          .fromTo(q('.pg-fade'), { autoAlpha: 0, y: 18, filter: 'blur(6px)' }, { autoAlpha: 1, y: 0, filter: 'blur(0px)', duration: 1, ease: 'expo.out', stagger: 0.08, clearProps: 'filter' }, 0.45)
          .fromTo(ring, { strokeDasharray: len, strokeDashoffset: len }, { strokeDashoffset: 0, duration: 1.8, ease: 'power3.inOut' }, 0);
        gsap.to(q('.pg-ring'), {
          rotate: 40,
          ease: 'none',
          scrollTrigger: { trigger: root.current, start: 'top top', end: 'bottom top', scrub: true },
        });
      });
      return () => mm.revert();
    },
    { scope: root }
  );

  return (
    <section className={`pg-hero ${compact ? 'pg-hero--compact' : ''} ${className}`} ref={root}>
      <svg className="pg-ring" viewBox="26 26 162 162" aria-hidden focusable="false">
        <path d={RING_PATH} fill="none" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" vectorEffect="non-scaling-stroke" />
      </svg>
      <div className="container pg-hero-inner">
        <h1 className="pg-title">
          {lines.map((l, i) => {
            const text = typeof l === 'string' ? l : l.text;
            const accent = typeof l !== 'string' && l.accent;
            return (
              <span className="pg-line" key={i}>
                <span className={`pg-rise ${accent ? 'is-accent' : ''}`}>{text}</span>
              </span>
            );
          })}
        </h1>
        {lede && <p className="pg-lede pg-fade">{lede}</p>}
        {children && <div className="pg-actions pg-fade">{children}</div>}
      </div>
    </section>
  );
}

export default PageHero;
